import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { formatUsd, signedUsd } from "../lib/format";
import { useAuth } from "../store/auth";

export function PortfolioPage() {
  const { user } = useAuth();
  const q = useQuery({
    queryKey: ["portfolio"],
    queryFn: () => api<{
      availableMicro: string; reservedMicro: string; investedMicro: string; totalMicro: string;
      unrealizedPnlMicro: string; realizedPnlMicro: string; winRate: number | null;
      active: Array<Record<string, unknown>>; resolved: Array<Record<string, unknown>>;
    }>("/portfolio"),
    enabled: !!user,
  });
  if (!user) return <div className="wrap empty"><h3>Sign in to see your portfolio.</h3><Link to="/login" className="btn btn-primary">Sign in</Link></div>;
  if (q.isLoading) return <div className="wrap"><div className="skeleton" style={{ height: 40 }} /></div>;
  const d = q.data!;
  if (!d.active.length && !d.resolved.length) {
    return (
      <div className="wrap empty">
        <h3>No positions yet.</h3>
        <p>Your portfolio will appear here after your first trade.</p>
        <Link to="/markets" className="btn btn-primary">Explore markets</Link>
      </div>
    );
  }
  return (
    <div className="wrap">
      <div className="page-head">
        <span className="kicker">Positions</span>
        <h1>Portfolio</h1>
        <p>Balances and contracts from the ledger — not a statement of expected value.</p>
      </div>
      <div className="grid-3">
        <Stat label="Total" v={formatUsd(d.totalMicro)} />
        <Stat label="Available cash" v={formatUsd(d.availableMicro)} />
        <Stat label="Invested" v={formatUsd(d.investedMicro)} />
        <Stat label="Unrealized P/L" v={signedUsd(d.unrealizedPnlMicro)} />
        <Stat label="Realized P/L" v={signedUsd(d.realizedPnlMicro)} />
        <Stat label="Win rate" v={d.winRate == null ? "—" : `${Math.round(d.winRate * 100)}%`} />
      </div>
      <h2>Active positions</h2>
      <PosTable rows={d.active} />
      <h2>Resolved</h2>
      <PosTable rows={d.resolved} />
    </div>
  );
}

function Stat({ label, v }: { label: string; v: string }) {
  return <div className="card"><div style={{ color: "var(--muted)" }}>{label}</div><strong style={{ fontSize: 22 }}>{v}</strong></div>;
}

function PosTable({ rows }: { rows: Array<Record<string, unknown>> }) {
  if (!rows.length) return <p className="empty">None.</p>;
  return (
    <div className="table-scroll"><table className="table">
      <thead><tr><th>Market</th><th>YES</th><th>NO</th><th>Value</th><th>P/L</th></tr></thead>
      <tbody>
        {rows.map((r) => (
          <tr key={String(r.id)}>
            <td><Link to={`/markets/${r.slug}`}>{String(r.question)}</Link></td>
            <td>{String(r.yes_shares)}</td>
            <td>{String(r.no_shares)}</td>
            <td>{formatUsd(String(r.currentValueMicro))}</td>
            <td>{signedUsd(String(r.unrealizedPnlMicro))}</td>
          </tr>
        ))}
      </tbody>
    </table></div>
  );
}
